import {
    REASSIGN_OVERRIDE,
    REASSIGN_OVERRIDE_SUCCESS,
    REASSIGN_OVERRIDE_FAILURE,
    RESET_REASSIGN_OVERRIDE,
} from '../actions';

const initialState = {
    loading: false,
    response: null,
    statusCode: '',
    statusMessage: '',
};

const reassignOverrideReducer = (state = initialState, action) => {
    switch (action.type) {
        case REASSIGN_OVERRIDE:
            return {
                ...state,
                loading: true,
                response: null,
                statusCode: '',
                statusMessage: '',
            };
        case REASSIGN_OVERRIDE_SUCCESS:
            return {
                ...state,
                loading: false,
                response: action.data,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case REASSIGN_OVERRIDE_FAILURE:
            return {
                ...state,
                loading: false,
                response: null,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case RESET_REASSIGN_OVERRIDE:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default reassignOverrideReducer;